import adicionalRouters from '@/modules/outros/adicional/router';
import entradaRouters from '@/modules/estoque/entrada/router';
import contagemEstoqueRouters from '@/modules/estoque/contagemEstoque/router';

export default [...adicionalRouters, ...entradaRouters, ...contagemEstoqueRouters];
